import {Directive, ElementRef, Input, OnDestroy, OnInit, Renderer, TemplateRef, ViewContainerRef} from '@angular/core';
// import {DwActionAuthorizedService} from '@webdpt/framework';
import {ActivatedRoute} from '@angular/router';
import {catchError} from 'rxjs/operators';
import {FieldAuthorizedService} from './field-authorized.service';

@Directive({
  selector: '[fxFieldAuthorized]'
})
export class FieldAuthorizedDirective implements OnInit {

  @Input() fxAuthorizedId: string; // 作業權限ID
  @Input() fxFieldId: string; // 功能按鈕ID
  @Input() fxDefaultAuthorized: string; // 預設權限 hidden, disabled
  private hasView = false;
  constructor(private elf: ElementRef,
              private renderer: Renderer,
              private activatedRoute: ActivatedRoute,
              private fieldAuthorizedService: FieldAuthorizedService) {
  }

  async ngOnInit(): Promise<any> {
    // 设置默认状态
    if (this.fxDefaultAuthorized) {
      this.setAttribute(this.fxDefaultAuthorized);
    }
    const state = await this.getCurrentStateId();
    if (state) {
      this.actionAuthorizedInit(this.fxAuthorizedId, this.fxFieldId);
    }
  }

  private actionAuthorizedInit(authorizedId: string, actionId: string): void {
    if (authorizedId && actionId) {
      // this.setAttribute('hidden');
      this.fieldAuthorizedService.setActionAuth(authorizedId, actionId);
      this.fieldAuthorizedService.fieldAuthorizedSubject$.subscribe(
        restriction => {
          this.setAttribute(restriction);
        },
        error => {
          console.log(actionId + ':' + error);
        }
      );
    }
  }

  async getCurrentStateId(): Promise<string> {
    if (this.fxAuthorizedId) {
      return this.fxAuthorizedId;
    }
    let currentSate = '';
    try {
      const routeData = await this.activatedRoute.data.toPromise();
      if (routeData['dwRouteData'] && routeData['dwRouteData'].hasOwnProperty('dwAuthId')) {
        currentSate = routeData['dwRouteData'].dwAuthId;
      }
    } catch (e) {
      console.error(e);
    }
    return currentSate;
  }

  private setAttribute(restriction: string): void {
    switch (restriction) {  // 按鈕功能限制：allow 允許, hidden 隱藏, disabled 禁用
      case 'allow': // 允許
        this.seAttributeAllow();
        break;
      case 'hidden': // 隱藏
        this.seAttributeHidden(true);
        break;
      case 'disabled': // 禁用
        this.seAttributeDisabled(true);
        this.seAttributeHidden(false);
        break;
    }
  }

  // 允許
  private seAttributeAllow(): void {
    this.seAttributeHidden(false);
    this.seAttributeDisabled(false);
  }

  // 隱藏
  private seAttributeHidden(isHidden: boolean): void {
    let display = '';
    if (isHidden) {
      display = 'none';
    }
    this.renderer.setElementStyle(this.elf.nativeElement, 'display', display);
  }

  // 禁用
  private seAttributeDisabled(isDisabled: boolean): void {
    this.elf.nativeElement.disabled = isDisabled;
    this.renderer.setElementClass(this.elf.nativeElement, 'dw-f-action-disable', isDisabled);
  }
}
